/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.commentModule')
  .controller('CommentController', ['BulbCommentService', 'BulbModalService', CommentController]);

/**
 * AngularJS controller for comment view.
 */
function CommentController(BulbCommentService, BulbModalService) {

  const that = this;
  this.pageComment = null;
  // FUTURE JDK BULB-2859 : This is temporarily disabled until the custom work for CKEditor commenting is completed.
  this.isCommentPrivate = false; // BulbCommentService.canMakePrivateComment(BulbPageService.page);
  // FUTURE JDK BULB-2859 : This is temporarily disabled until the custom work for CKEditor commenting is completed.
  this.canMakePrivateComment = false; // BulbCommentService.canMakePrivateComment(BulbPageService.page);
  this.menuVisible = false;
  this.currentEditingCommentId = null;
  this.currentEditingCommentContent = null;

  this.switchMenu = function (event) {
    this.menuVisible = !this.menuVisible;
    event.stopPropagation();
  };

  this.consumeEvent = function (event) {
    event.stopPropagation();
  };

  this.switchArchivedVisible = function () {
    BulbCommentService.showArchivedComments = !BulbCommentService.showArchivedComments;
    BulbCommentService.refreshBubbleButtons();
    BulbCommentService.api.updateAccountPreferences();
  };

  this.switchReply = function (thread) {
    const currentValue = (BulbCommentService.lowerCommentExpanded[thread.id] === true);
    BulbCommentService.lowerCommentExpanded[thread.id] = !currentValue;

    // Mark all children to have the same visibility as the parent
    for (let i = 1; i < thread.comments.length; i++) {

      thread.comments[i].privateComment = thread.privateComment;
      thread.comments[i].isQuotation = thread.quotation;
    }
  };

  this.comment = function (thread) {
    BulbCommentService.draftThread = null;
    if (thread.comments && thread.comments.length) {
      BulbCommentService.lowerCommentExpanded[thread.id] = true;
      BulbCommentService.api.comment(thread, BulbCommentService.threadComment[thread.id], that.isCommentPrivate)
        .then(that.resetCommentState(thread.id));
    } else {
      BulbCommentService.api.createThread(
        thread.targetId,
        thread.quotation,
        BulbCommentService.threadComment[thread.id],
        that.isCommentPrivate,
      ).then(
        that.resetCommentState(thread.id),
      );
    }
  };

  this.commentPage = function () {
    if (this.pageComment && this.pageComment.length > 0) {
      BulbCommentService.api.commentPage(this.pageComment, this.isCommentPrivate).then(that.resetCommentState());
    }
  };

  /**
   * Reset comment state and clean up variables for next use.
   * @param threadId If this is specified, we do a thread clean up if not we do a general comment clean up
   */
  this.resetCommentState = function (threadId) {

    if (threadId) {
      BulbCommentService.threadComment[threadId] = '';
    } else {
      that.pageComment = null;
    }
    // FUTURE: uncomment this as soon as we resume the private comment functionality.
    // that.isCommentPrivate = BulbCommentService.canMakePrivateComment();
  };

  this.editComment = function (comment) {
    this.currentEditingCommentId = comment.id;
    this.currentEditingCommentContent = comment.content;
  };

  const initCommentEditing = function (form) {
    that.currentEditingCommentId = null;
    that.currentEditingCommentContent = null;
    form.$pristine = true;
  };

  this.updateComment = function (thread, comment, form) {
    BulbCommentService.api.updateComment(thread, that.currentEditingCommentId, that.currentEditingCommentContent).then((res) => {
      comment.content = that.currentEditingCommentContent;
      initCommentEditing(form);
    });
  };

  this.cancelEdit = function (form) {
    initCommentEditing(form);
  };

  this.deleteComment = function (thread, commentId) {
    BulbModalService.showMessage('comment_delete_comment_confirm', {
      windowClass: '',
      okButtonCode: 'button_delete',
      showCancelButton: true,
    }).then((res) => {
      res.result.then(() => {
        BulbCommentService.api.deleteComment(thread, commentId);
      });
    });
  };

  this.deleteCommentThread = function (thread) {
    // if this is the newly created comment thread, prevent deleting it.
    if (thread.comments.length === 0) {
      return;
    }

    BulbModalService.showMessage('comment_delete_comment_thread_confirm', {
      windowClass: '',
      okButtonCode: 'button_delete',
      showCancelButton: true,
    }).then((res) => {
      res.result.then(() => {
        BulbCommentService.api.deleteThread(thread).then(() => {
          BulbCommentService.updateCommentThreads(thread.targetId);
          BulbCommentService.updateCommentButtons();
        });
      });
    });
  };

  const processArchiving = function (confirmMessageCode, thread, archived) {
    BulbModalService.showMessage(confirmMessageCode, {
      windowClass: '',
      okButtonCode: archived ? 'button_archive' : 'button_unarchive',
      showCancelButton: true,
    }).then((res) => {
      res.result.then(() => {
        BulbCommentService.api.archiveThread(thread, archived).then(() => {
          BulbCommentService.refreshBubbleButtons();
        });
      });
    });
  };

  this.archive = function (thread) {
    processArchiving('comment_archive_comment_thread_confirm', thread, true);
  };

  this.unarchive = function (thread) {
    processArchiving('comment_unarchive_comment_thread_confirm', thread, false);
  };

  this.cancel = function (commentThread) {
    BulbCommentService.removeDraftThread();
  };

  this.getActiveCommentIdx = function () {
    return BulbCommentService.activeCommentIdx;
  };

  this.activate = function (idx) {
    BulbCommentService.activeCommentIdx = idx;
  };

  const fadeOutWaitTime = 1000;

  this.processCommentInView = function (inview, thread, comment) {
    if (inview) {
      BulbCommentService.readComment(thread, comment, fadeOutWaitTime);
    }
  };
}
